(function(){
    angular
        .module('appback')
        .directive('ngSubanaliticasinterpretacion', subanaliticasinterpretacion);

        subanaliticasinterpretacion.$inject = ['GenerallabService','$uibModal','ResultadosService','$timeout'];
        function subanaliticasinterpretacion(GenerallabService,$uibModal,ResultadosService,$timeout){
            return {
	            //require: 'ngModel',
	            templateUrl: '/backend/resultadopeticion/template?name=subanaliticasinterpretacion.twig',
		          scope: {
                  //ngModel : '=',
                  item: '=',
                  animal: '=',
                  peticion:'=',
                  categoria:'=',
                  centro:'='
              	},
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {

                        scope.generalLab = GenerallabService;
                        scope.loading = true;
                        scope.dilucionModal = "";
                        //console.log("hem",scope.item.resultado.extra.resultado);
                        if(!scope.item.resultado){
                            scope.item.resultado = { extra : { resultado : { subanalitica : { created:''}, config : {dilucion:1} }}};
                        }else{
                            if(!scope.item.resultado.extra){
                            scope.item.resultado.extra = { resultado : {subanalitica : { created:''} }};
                            }else{
                                if(!scope.item.resultado.extra.resultado){
                                    scope.item.resultado.extra.resultado = { subanalitica : { created:''}};
                                }else{
                                    if(Array.isArray(scope.item.resultado.extra.resultado)){
                                    scope.item.resultado.extra.resultado = { subanalitica : { created:''}};
                                    }
                                }
                            }
                        }
                        
		            	//console.log(scope);
		            	scope.subanaliticas = [];
		            	ResultadosService.getSubanaliticasByAnalitica(scope.item.analitica_id,scope.animal.especie_id,scope.centro.idioma_code,function(data){
                            scope.loading = false;
			                scope.subanaliticas = data.subanaliticas;
                            for(var cont=0;cont<scope.subanaliticas.length;cont++){
                                if(typeof(scope.item.resultado.extra.resultado.subanalitica[scope.subanaliticas[cont].codigo_alfa])=='undefined'){
                                    scope.item.resultado.extra.resultado.subanalitica[scope.subanaliticas[cont].codigo_alfa] = { resultado : ''};
                                    
                                }
                                scope.subanaliticas[cont].resultado = scope.item.resultado.extra.resultado.subanalitica[scope.subanaliticas[cont].codigo_alfa];
                                scope.generalLab.setInterpretacionesSubanalitica(scope.item,scope.subanaliticas[cont]);
                            }
                            scope.generalLab.getInterpretacionesCategoria(scope.peticion,scope.categoria);

			            });

                    scope.valorNormalidad = function(analitica){
                        var resultado = false;
                        if(analitica.valoresnormalidad.interpretacion){
                            for(var cont = 0;cont<analitica.valoresnormalidad.interpretacion.length && !resultado;cont++){
                            if(angular.isDefined(scope.item.resultado.extra.resultado.subanalitica)){
                                if(typeof(scope.item.resultado.extra.resultado.subanalitica[analitica.codigo_alfa]) != 'undefined' && ((analitica.valoresnormalidad.interpretacion[cont].from=='' || parseFloat(scope.item.resultado.extra.resultado.subanalitica[analitica.codigo_alfa].resultado)>=parseFloat(analitica.valoresnormalidad.interpretacion[cont].from)) && (analitica.valoresnormalidad.interpretacion[cont].to=='' || parseFloat(scope.item.resultado.extra.resultado.subanalitica[analitica.codigo_alfa].resultado)<parseFloat(analitica.valoresnormalidad.interpretacion[cont].to)))){
                                    resultado = analitica.valoresnormalidad.interpretacion[cont];
                                    console.log("resultado", resultado);
                                }
                            }
                            }
                        }
                        return resultado;
                    }

                });
            }
          }
      }
})();